import React from 'react';
import Product from './Product';

const Products = (props) => {

  const {heading,logoprodimage, products} = props.data;
  const {amounts, der, mealsPerDay, wetFoodAmountLabel} = props;
  const animalState = props.animalState

  const isMultipleProducts = products.length > 1;
  const productCount = products.length;

  if (products) {
    return (
      <div className="nppe2-fc-feeding-guidelines-products" id="fc-screenshot-feeding-guidelines-products">
        <div className="row">
          <div className="col-xs-12 nppe2-fc-sub-title-output">
            {heading}
          </div>
          <div className="col-xs-12 nppe2-fc-feeding-guidelines-products__item-wrapper">
            {products.map((product, index) => (
              <Product
                key={index}
                data={product}
                der={der}
                amounts={amounts}
                mealsPerDay={mealsPerDay}
                isMultipleProducts={isMultipleProducts}
                productCount={productCount}
                wetFoodAmountLabel={wetFoodAmountLabel}
              />
            ))}
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className="row nppe2-fc-feeding-guidelines-products" id="fc-screenshot-feeding-guidelines-products"></div>
    )
  }
}

export default Products;
